export function formatVersionAsReleaseDate(version: string): string {
  if (version === 'local-dev') {
    return 'Development Build';
  }

  const match = version.match(/^\d+\.(\d{4})(\d{2})(\d{2})\.\d+$/);
  if (!match) {
    return `v${version}`;
  }

  const [, year, month, day] = match;
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  const monthName = date.toLocaleString('en-US', { month: 'long' });
  return `Release Date: ${monthName} ${parseInt(day)}, ${year}`;
}

// The displayed version cannot identify a deployed image (the Docker build stage has no CI env,
// so every image bakes 'local-dev'); the pipeline build number can, so it is offered on hover.
// Returns undefined when there is no build number, because docker/env.sh always emits the key
// (as "" for local builds) and title={undefined} omits the attribute entirely.
export function formatBuildNumberTooltip(buildNumber: string | undefined): string | undefined {
  const trimmed = buildNumber?.trim();
  return trimmed ? `Build ${trimmed}` : undefined;
}
